<template>
	<div>
		<banner></banner>
		
		<div class="tab __pb __pt">
			<div class="wrapper">
				<h1 class="header-block_title">Лига чемпионов</h1>
				
				<tournament-header-main></tournament-header-main>
				
				<div class="tab_content">
					<div class="tab_block active" id="block-2">
						<matches :type="info.sport" :show-date="true" :list="notStartedMatches" :show-title="false"></matches>
					</div>
					<div class="tab_block" id="block-1">
						<matches v-if="finishedMatches" :type="info.sport" :list="finishedMatches" :show-title="false"></matches>
						<div class="info-text" style="padding-top: 10px;" v-else>Загрузка...</div>
						
						<div v-if="finishedMatches" class="tab_button">
							<router-link to="/tournament/42">Еще матчи</router-link>
						</div>
					</div>
					<div class="tab_block __margin" id="block-3">
						<standings :data="standings"></standings>
					</div>
					<div class="tab_block" id="block-4">
						<div class="last-news __pt">
							<div class="last-news_row" v-for="newsItem in news" :key="newsItem.id">
								<router-link :to="{ name: 'news-item', params: {id: newsItem.id} }" class="last-news_title">
									{{ newsItem.title }}
								</router-link>
								
								<div class="last-news_date">
									{{ getTime(newsItem.pub_date) }}
								</div>
							</div>
						</div>
					</div>
					<div class="tab_block" id="block-5">
						<scorers :data="scorers"></scorers>
					</div>
				</div>
			</div>
		</div>
	
		<news :sport="sport"></news>
		
		<videos :sport="sport"></videos>
	
		<games :sport="sport"></games>
	</div>
</template>

<script>
	import moment from 'moment';
	import _ from 'underscore';
	
	import HomeMatches from "../components/Match/HomeMatches";
	import News from "../components/News/News";
	import Videos from "../components/Videos/Videos";
	import Games from "../components/Games/Games";
	import Banner from "../components/Layout/Banner";
	import TournamentHeaderMain from "../components/Tournaments/TournamentHeaderMain";
	import Matches from "../components/Match/Matches";
	import Standings from "../components/Standings/Standings";
	import Scorers from "../components/Scorers/Scorers";
	
	export default {
		components: {
			News,
			Videos,
			Games,
			Banner,
			TournamentHeaderMain,
			Matches,
			Standings,
			Scorers
		},
		
		data() {
			return {
				info: {},
				sport: null,
				matches: {},
				finishedMatches: null,
				notStartedMatches: {},
				news: [],
			}
		},
		
		created() {
			this.sport = this.$route.params.sport ? this.$route.params.sport : '';
			
			this.initEvents();
		},
		
		computed: {
			standings() {
				var standings = this.info.standings || [];
				
				standings = standings.filter((item, key) => {
					return item.stage_name.search('2019/2020') !== -1;
				});
				
				return standings;
			},
			scorers() {
				return this.info.topscorer;
			}
		},
		
		methods: {
			initEvents() {
				this.axios.get('/api/events?limit=8&status=finished&order=startdate&tournament_id=' + 42)
					.then(({data}) => {
						this.finishedMatches = data;
					});

				this.axios.get('/api/events?tournament_id=' + 42 + '&status=notstarted')
					.then(({data}) => {
						this.notStartedMatches = data;
					});

				this.axios.get('/api/tournaments/' + 42)
					.then(({data}) => {
						this.info = data;
					});

				this.axios.get('/api/news?rubric=1882')
					.then(({data}) => {
						this.news = data.data;
					});
			},
			
			isCurrentSport(sport) {
				return !(this.sport && this.sport !== sport);
			},
			getTime(date) {
				return moment(date).locale('ru').format('D MMMM Y, HH:mm');
			},
		}
	}
</script>